/** Legacy Basic-auth credential storage (base64 user:pass). */
export const AUTH_STORAGE_KEY = "auth-data";
export const ACCESS_TOKEN_KEY = "taxos-access-token";
export const REFRESH_TOKEN_KEY = "taxos-refresh-token";